import {
    changeEvent,
    customEvent,
    dispatchCustomEvent,
} from "../../../../../webpack/modules/events";
import {previewOption, trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {hideOffcanvas, showOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {hideOptionErrors} from "../../../../../webpack/modules-optimized/product-page";
import {slideUp, slideDown} from "../../../../../webpack/modules-optimized/element-visibility";

customEvent('show.bs.offcanvas', `.offcanvas[data-type="size"]`, true, function(element, e) {
    let materialCanvas = document.querySelector('.offcanvas[data-type="material-canvas"]');
    if (materialCanvas && !materialCanvas.querySelector('input[name="material-canvas"]:checked')) {
        e.preventDefault();
        e.stopPropagation();
        let error = materialCanvas.querySelector('.general-error');
        slideDown(error);
        showOffcanvas(materialCanvas.id);
    }
});

changeEvent('#product-page input[name="material-canvas"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let materialCanvas = offcanvas.querySelectorAll('.material-canvas');
    let materialCanva = element.nextElementSibling;
    let error = offcanvas.querySelector('.error');
    let offcanvasSize = container.querySelector('.offcanvas[data-type="size"]');
    let previewElementSize = container.querySelector('.open-options[data-bs-target="#' + offcanvasSize.id + '"] .preview');

    dispatchCustomEvent(
        'productMaterialCanvasChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
        }
    );

    slideUp(error);
    materialCanvas.forEach((materialCanva) => materialCanva.classList.remove('selected'));
    materialCanva.classList.add('selected');

    document.querySelectorAll('#product-page input[name="size"]').forEach(function (size) {
        size.checked = false;

        if (size.dataset.material === element.value) size.nextElementSibling.classList.remove('d-none');
        else size.nextElementSibling.classList.add('d-none');
    });

    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');

    //UPDATE ID WITH PRODUCTION
    if (element.value === '2') {
        let complement = document.querySelector('#product-page input[name="complement"][value="90982"]');
        if (complement) {
            complement.checked = false;
            complement.closest('.complement').classList.add('d-none');
        }
    } else {
        let complement = document.querySelector('#product-page input[name="complement"][value="90982"]');
        if (complement) {
            complement.checked = true;
            complement.closest('.complement').classList.remove('d-none');
        }
    }

    hideOptionErrors(offcanvas);
    hideOffcanvas(offcanvas.id);
    previewOption(offcanvasSize, previewElementSize);
    // trackProductPageGa4Events('MaterialCanvas', element.dataset.preview);
});


